import { api } from '@/store/api'
import type { Instruction, InstructionListResponse } from './types'
import { arrayOrPaged } from './instructionsApi.tags'

const PAGE_SIZE = 50
const MAX_PAGES = 40

/**
 * ВСЕ статьи автора одним списком — для страницы «Мои инструкции»: фильтры, поиск и
 * порционный показ при прокрутке работают по всем статьям, а не по первой странице.
 * Постраничный `getMyInstructions` остаётся для пикера статьи в редакторе.
 */
export const myInstructionsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getAllMyInstructions: build.query<Instruction[], void>({
      queryFn: async (_arg, _api, _extra, baseQuery) => {
        const items: Instruction[] = []
        for (let page = 1; page <= MAX_PAGES; page++) {
          const res = await baseQuery({
            url: 'instructions/my',
            params: { page, page_size: PAGE_SIZE },
          })
          if (res.error) return { error: res.error }
          const body = arrayOrPaged(res.data as InstructionListResponse | Instruction[])
          items.push(...body.items)
          const done =
            body.items.length < PAGE_SIZE ||
            (body.total !== undefined && items.length >= body.total)
          if (done) break
        }
        return { data: items }
      },
      providesTags: [{ type: 'Instruction' as const, id: 'MY_LIST' }],
    }),
  }),
})

export const { useGetAllMyInstructionsQuery } = myInstructionsApi
